import React, { useState, useEffect } from 'react';
import {useTranslation} from 'react-i18next';
import translate from '../../../../helpers/translate';
import Margin from '../../../../components/shared/margin';
import Head from '../../../../components/shared/head';
import {commonStyles as stylesCommon} from '../../../../styles/common';
import {useSelector} from 'react-redux';
import Item from './intenList';
import LayoutContent from '../../../../components/layouts/content2';
import { styles } from './styles';
import {useNavigate, useLocation} from 'react-router-dom';
import { Link } from 'react-router-dom';

function Index() {
    const data = useLocation().state;
    const urlSegments = window.location.pathname.split('/');
    const categorie_id = urlSegments[urlSegments.length - 1];
    const hash = urlSegments[urlSegments.length - 2];

    const navigate = useNavigate();
    const {allmenu} = useSelector((state) => state.initLoad);
    
    const commonStyles  = stylesCommon(); 
    
    const {t, i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menu, setMenu] = useState([]);
    const [titleCategorie, setIitleCategorie] = useState('');
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState(null);

    // Estilos para la barra horizontal de categorías
    const categoryBarStyle = {
        display: 'flex',
        overflowX: 'auto',
        padding: '15px 10px',
        width: '100%',
        background: '#fff',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        gap: '10px'
    };

    const categoryItemStyle = {
        padding: '5px 11px',
        borderRadius: '25px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        textDecoration: 'none',
        fontWeight: 'bold',
        fontSize: '11px',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
    };

    const activeItemStyle = {
        ...categoryItemStyle,
        backgroundColor: '#e63946',
        color: 'white'
    };

    const inactiveItemStyle = {
        ...categoryItemStyle,
        backgroundColor: '#f8f9fa',
        color: '#333'
    };

    function capitalizeWords(str) {
        if (!str) return '';
        return str.toLowerCase().split(' ').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
    }

    useEffect(()=>{
        if (allmenu) {
            const categorieItem = allmenu.data.find(
                (item) => 
                    item.id == categorie_id
                );
        
            if (categorieItem) {
                console.log({categorieItem})
                setMenu(categorieItem.menus);
                setIitleCategorie(langEng ? 
                                categorieItem.name 
                            :    
                                translate(i18n.language, categorieItem.language, categorieItem.name));
                setActiveCategory(parseInt(categorie_id));
            }

            // Cargar todas las categorías disponibles
            if (allmenu.data && allmenu.data.length > 0) {
                // Filtrar las categorías que no están en la lista de IDs excluidos
                const filteredCategories = allmenu.data.filter(item => 
                    ![339, 387, 389, 390, 391, 393, 392, 395,
                        396, 399, 400, 401, 402, 403, 404,
                        405, 406, 407, 408, 409, 410, 411, 412, 414, 415, 416, 417, 419, 418, 557, 556, 590].includes(item.id)
                );
                setCategories(filteredCategories);
            }
        }
    }, [allmenu, categorie_id]);
                            
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
          setWindowWidth(window.innerWidth);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
    }, []);

    let contentStyles;

    if (windowWidth >= 1024) {
      contentStyles = styles.contentRecommendedDesktop;
    } else if (windowWidth >= 768) {
      contentStyles = styles.contentRecommendedTablet;
    } else {
      contentStyles = styles.contentRecommendedMobile;
    }

    return (
        <LayoutContent isList={true}>
            <div style={styles.content}>
                <Margin top={15} />
                  
                {/* Barra horizontal de categorías */}
                <div style={categoryBarStyle}>
                    {categories.map((category) => {

                        if (![339, 387, 389, 390, 391, 393, 392, 395, 614, 615, 617,
                            396, 399, 400, 401, 402, 403, 404,
                            405, 406, 407, 408, 409, 410, 411, 412, 414, 415, 416, 417, 419, 418, 557, 556, 590].includes(category.id)) {
                            return(
                                <Link
                                key={category.id}
                                to={category.id === 352 ? '/sandwich' :
                                    category.id === 216 ? '/quesadillas' :
                                        category.id === 221 ? '/tacos' :
                                            category.id === 217 ? '/burrito' :
                                                category.id === 211 ? '/drinks' :
                                                    category.id === 112 ? '/special' :
                                                        `/MenuList/${hash}/${category.id}`}
                                state={{ categorie: category }}
                                style={parseInt(categorie_id) === category.id ? activeItemStyle : inactiveItemStyle}
                            >
                                {capitalizeWords(category.name)} <br /> / {capitalizeWords(translate(i18n.language, category.language, category.name))}
                            </Link>
                            )
                        }
                    })}
                </div>
                
                <div style={{...contentStyles, ...{paddingInline: 20, position: 'relative'}}}>
                    {menu &&
                        menu.map((item) => (
                            <Item
                                key={item.id.toString()}
                                menu={item}
                                allDish={menu}
                                setShowQr={() => {}}
                                setUriShare={() => {}}
                                titleCategorie={''}
                            />
                        ))
                    }
                </div>
            </div>
            <Margin top={15} />
        </LayoutContent>
    );
}

export default Index;